// src/features/statistics/components/ActivityHourChart.tsx

import { Bar, BarChart, Cell, ResponsiveContainer, Tooltip, XAxis } from 'recharts';

import type { HourlyActivity } from '../types/audience';

type Props = {
  data: HourlyActivity[];
};

function interpolateBlue(ratio: number): string {
  const r = Math.round(30 + ratio * (96 - 30));
  const g = Math.round(58 + ratio * (165 - 58));
  const b = Math.round(95 + ratio * (250 - 95));
  return `rgb(${r},${g},${b})`;
}

export function ActivityHourChart({ data }: Props): JSX.Element {
  if (data.length === 0) {
    return (
      <div className="flex items-center justify-center h-20 text-sm text-muted-foreground">
        Нет данных
      </div>
    );
  }

  const maxValue = Math.max(...data.map(d => d.value), 1);

  return (
    <ResponsiveContainer width="100%" height={80}>
      <BarChart data={data} margin={{ top: 4, right: 0, left: 0, bottom: 0 }} barSize={8}>
        <XAxis
          dataKey="hour"
          tickFormatter={(h: number) => [0, 6, 12, 18, 23].includes(h) ? String(h) : ''}
          tick={{ fontSize: 10, fill: 'hsl(var(--muted-foreground))' }}
          tickLine={false}
          axisLine={false}
          interval={0}
        />
        <Tooltip
          formatter={(value: number) => [value.toLocaleString('ru-RU'), 'Подписчиков онлайн']}
          labelFormatter={(hour: number) => `${String(hour).padStart(2, '0')}:00`}
          contentStyle={{ fontSize: 12, borderRadius: 8 }}
          cursor={false}
        />
        <Bar dataKey="value" radius={[2, 2, 0, 0]}>
          {data.map(entry => (
            <Cell key={entry.hour} fill={interpolateBlue(entry.value / maxValue)} />
          ))}
        </Bar>
      </BarChart>
    </ResponsiveContainer>
  );
}
